export default "<div [innerHTML]=\"text | safeHtml\"></div>";